import { Component, OnInit } from '@angular/core';
import { IProduct } from "../../shared/product";
import { ProductDetail } from "../../shared/productDetail";
import { ActivatedRoute, Router } from "@angular/router";
import { DataService } from "../../shared/dataService";
import { IImage } from 'ng-simple-slideshow';
import { SlideshowModule } from 'ng-simple-slideshow';



@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.css']
})
export class ProductDetailComponent implements OnInit {
    
    pageTitle: string = "Product Detail";
    product: IProduct;
    theImageUrls: string[] = [
        "Images/carrousel_3.jpg",
        "Images/Products/Equipamiento/Midi Plus/BiodataMidiPlus.JPG"
    ];


    constructor(private route: ActivatedRoute, private router: Router,private data: DataService) {
        console.log(this.route.snapshot.paramMap.get('productId'));
    }

    featuredProducts(productDetails: ProductDetail[]) {
        var detailsFiltered = productDetails.filter(x => x.featured == true);
        return detailsFiltered;
    }
    ngOnInit(): void {
        var idGuid = this.route.snapshot.paramMap.get('productId');
        this.pageTitle += idGuid;

        this.data.loadProduct(idGuid)
            .subscribe(success => {
                if (success) {
                    this.product = this.data.product;

                    //this.product.images.forEach(function (value) {
                    //    this.imageUrls.push(value.fileName);
                    //}); 
                } else {
                    // TODO: Handle error
                    // error => this.errorMessage =<any>error
                    // Module "Retrieve data using http
                    // https://app.pluralsight.com/player?course=angular-2-getting-started-update&author=deborah-kurata&name=angular-2-getting-started-update-m9&clip=7&mode=live
                    // "Angular: Reactive forms"
                    // "Play by Play: Angular 2/RxJS/ HTtp and Restful services

                }
            });
    }

    onBack(): void {
        this.router.navigate(['/productTypes/'+this.product.productTypeId]);
    }
}
